/** Main layout breakpoint where most modules and blocks shift layout (tablet.lg, 80em). */
const BREAKPOINT_TABLET_LG_EM = '80em';

/** Below tablet.lg, quarter/slider sit in 8 columns of a 12-column grid (8/12 ≈ 67vw). */
const EIGHT_OF_TWELVE_COLUMNS_VW = '67vw';

export type LayoutImageWidthVariant = 'fullWidth' | 'halfWidth' | 'quarterWidth' | 'sliderWidth';

/** Returns the <img> sizes attribute for the given layout. Based on basic block and columnModule layouts. */
export const getLayoutImageSizes = (layout: LayoutImageWidthVariant = 'fullWidth'): string => {
    const mq = `(min-width: ${BREAKPOINT_TABLET_LG_EM})`;
    switch (layout) {
        case 'fullWidth':
            return '100vw';
        case 'halfWidth':
            return `${mq} 50vw, 100vw`;
        case 'quarterWidth':
            return `${mq} 25vw, ${EIGHT_OF_TWELVE_COLUMNS_VW}`;
        case 'sliderWidth':
            return `${mq} 30vw, ${EIGHT_OF_TWELVE_COLUMNS_VW}`;
        default:
            return '100vw';
    }
};
